import { takeLatest, put } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';
import actionTypes from './types';
import {
  fetchConsignerVehiclesSuccess,
  fetchFiltersSuccess,
  fetchItineraryDataSuccess,
  fetchPathDetailsSuccess,
  fetchCurrentLocationSuccess,
} from './actions';
import urls from './urls';
import get from 'lodash/get';
import { showSnackBar } from '../../../../components/UI/HOC/SnackBar/store/actions';
import { ResponseGenerator } from '../../../../utils/globalContracts';

function* fetchConsignerVehicles(action: { type: string; payload: Array<string> }) {
  const requestURL = urls.fetchConsignerVehicles(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (get(response, 'data.data')) {
      yield put(fetchConsignerVehiclesSuccess(response.data.data));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching consigner vehicles.' }));
    console.log({ e });
  }
}

function* fetchFilters(action: { type: string }) {
  const requestURL = urls.fetchFilters();
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (get(response, 'data.data')) {
      yield put(fetchFiltersSuccess(response.data.data));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching consigner vehicles.' }));
    console.log({ e });
  }
}

function* fetchItineraryData(action: { type: string; payload: number }) {
  const requestURL = urls.fetchItineraryData(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (get(response, 'data.data')) {
      yield put(fetchItineraryDataSuccess(response.data.data));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching itinerary data.' }));
    console.log({ e });
  }
}

function* fetchPathDetails(action: { type: string; payload: number }) {
  const requestURL = urls.fetchPathDetails(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (get(response, 'data.data')) {
      yield put(fetchPathDetailsSuccess(response.data.data));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching path details.' }));
    console.log({ e });
  }
}

function* fetchCurrentLocation(action: { type: string; payload: number }) {
  const requestURL = urls.fetchCurrentLocation(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (get(response, 'data.data')) {
      yield put(fetchCurrentLocationSuccess(response.data.data));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching current location.' }));
    console.log({ e });
  }
}

function* downloadReport(action: { type: string; payload: Array<string> }) {
  const requestURL = urls.downloadReport(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (response.data.success) {
      yield put(showSnackBar({ variant: 'success', message: 'Report will be mailed to the email shortly.' }));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching path details.' }));
    console.log({ e });
  }
}

function* updateConsignmentSaga() {
  yield takeLatest(actionTypes.FETCH_CONSIGNER_VEHCILES_START, fetchConsignerVehicles);
  yield takeLatest(actionTypes.FETCH_FILTERS_START, fetchFilters);
  yield takeLatest(actionTypes.FETCH_ITINERARY_DATA_START, fetchItineraryData);
  yield takeLatest(actionTypes.FETCH_PATH_DETAILS_START, fetchPathDetails);
  yield takeLatest(actionTypes.FETCH_CURRENT_LOCATION_START, fetchCurrentLocation);
  yield takeLatest(actionTypes.DOWNLOAD_REPORT, downloadReport);
}
export default updateConsignmentSaga;
